export const basicAnimationStates = {
  off: { opacity: 0 },
  on: { opacity: 1 },
};
